<template>
    <div>
        <v-tooltip
            bottom
            content-class="p-color-tooltip"
            v-if="!isMobile"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    v-bind="attrs"
                    v-on="on"
                    :ripple="false"
                    x-small
                    class="p-background-primary"
                    :disabled="disabled"
                    depressed
                    @click="$emit('click')"
                >
                    <slot></slot>
                </v-btn>
            </template>
            <div class="d-flex align-center">
                <v-icon class="p-color-dark">mdi-hand-pointing-right</v-icon>
                <h1 class="app-private-title-dark ml-1">{{smsToolTip}}</h1>
            </div>
        </v-tooltip>
        <v-btn
            v-else
            fab
            :ripple="false"
            x-small
            class="p-background-primary"
            :disabled="disabled"
            depressed
            @click="$emit('click')"
        >
            <slot></slot>
        </v-btn>
    </div>
</template>
<script>
export default {
    props: {
        smsToolTip: String,
        disabled: Boolean,
        isMobile: Boolean
    }
}
</script>